export const PRE_POLICYPLACEMENT_CONSTANTS = {
  isPolicyPlacementDoneWithTrovity: "Please Select Atleast One Option",
  whoIsTheIntermediary: "Please Enter Intermediary",
  reasonForTheNonMaterializationOfTheProposal:
    "Please Select Reason For The NonMeterialization Of The Proposal",
  policyStartDate: "Please Select Policy Start Date",
  policyEndDate: "Please Select Policy End Date",
  leadInsurer: "Please Select Lead Insurer",
  insurerBranch: "Please Enter Insurer Branch",
  netPremiumPaid: "Please Enter Net Premium Paid",
  grossPremium: "Please Enter Net Premium Paid",
  paymentMode: "Please Select Payment Mode",
  paymentReferenceNumber: "Please Enter Payment Reference Number",
  paymentDate: "Please Select Payment Date",
  financierName: "Please Enter Financier Name",
  pan: "Please Upload Pan",
  aadhar: "Please Upload Aadhar",
  gstCertificate: "Pleaase Upload GST Certificate",
};

export const POLICY_DOCUMENT_DETAILS_CONSTANTS = {
  policyNumber: "Please Enter Policy Number",
  isPolicyThroughlyReviewed: "Please Select Atleast One Option",
  policyDocument: "Please Upload Policy Document",
  finalRfq: "Please Upload Final RFQ",
  finalQcr: "Please Upload Final QCR",
  mandateCopy: "Please Upload Mandate Copy",
  isPolicyPremiumIsPaidInInstallments: "Please Select Atleast One Option",
  isC52IdYes: "Please Enter IsC52IdYes",
};
